import React from 'react'
import styled from 'styled-components';
import phoneFrame from '../images/iphone.png';

const Wrapper = styled.div`
  position: relative;
`;

const Frame = styled.img``;
const Screen = styled.img`
  position: absolute;
  top: 12%;
  left: 6%;
  width: 88%;
`;

const PhoneScreen = ({ src }) => (
  <Wrapper>
    <Frame src={phoneFrame} />
    <Screen src={src} />
  </Wrapper>
);

export default PhoneScreen;

